import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import styled from "styled-components";
import { fetchProducts } from "../../actions/appointmentActions";
import {
  fixTime,
  fixDate,
  refreshTimeout,
  refreshAlertText
} from "../../helpers";
import md5 from "md5";
import "./InstructorDashboard.css";

import ScheduleEntryTitle from "../core/ScheduleEntryTitle";
import MustPay from "../core/MustPay";
import BackButton from "../core/BackButton";
import CardGroup from "../core/CardGroup";
import Paragraph from "../core/Paragraph";

const mapStateToProps = state => {
  return {
    appointments: state.appointments.appointments,
    loading: state.appointments.loading,
    error: state.appointments.error
  };
};
const PaymentWarning = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  span {
    color: #e65554;
    font-weight: 700;
  }
`;
class InstructorDashboard extends Component {
  state = {
    appointment: null,
    body: null,
    newPayments: null
  };
  appointmentDebounce = debounce(() => {
    const oldData = md5(JSON.stringify(this.state.appointment));
    localStorage.setItem("oldData", oldData);
    this.props.dispatch(fetchProducts()).then(() => this.updateDisplay());
  }, refreshTimeout);
  headers = {
    appointment: ["Instructor Notes"],
    student: [
      "Student #",
      "Student Name",
      "Cell Number",
      "Day Number",
      "Night Number",
      "Aux Number",
      "Text Number",
      "Email"
    ],
    lesson: [
      "Package Detail",
      "Number of Lessons Purchased",
      "Number of Lessons Taken",
      "Number of Lessons Scheduled",
      "Date of Last Lesson",
      "Date of Next Lesson"
    ],
    road_test: [
      "Appointment Date",
      "Appointment Time",
      "Appointment Site",
      "With or With Out Car"
    ]
  };
  loadRecentPayments = StudentID => {
    const newState = { ...this.state };
    // StudentID = 1;
    fetch(
      `http://brooklyndrives.mystack.co/wp-json/student/payments/${StudentID}`
    )
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(json => {
        if (json.data) {
          const totalpayment = json.data.reduce(
            (total, current) => total + parseInt(current.total),
            0
          );
          newState.newPayments = totalpayment;
          this.setState(newState);
        }
      });
  };
  // We are going to run this whenever the display should change.
  updateDisplay = () => {
    const day = this.props.match.params.day;
    const sid = this.props.match.params.sid;
    try {
      const index = this.props.appointments[day].findIndex(
        appointment => appointment.AppointmentID === sid
      );
      const data = this.props.appointments[day][index];
      const body = {
        appointment: [data.InstNotes],
        student: [
          data.StudentID,
          data.StudentName,
          data.StudentPhoneNumber[0],
          data.StudentPhoneNumber[1],
          data.StudentPhoneNumber[2],
          data.StudentPhoneNumber[3],
          data.StudentPhoneNumber[4],
          data.Email
        ],
        lesson: [
          data.Package_Info,
          data.NumLessonsPurchased,
          data.NumLessonsTaken,
          data.LessonsScheduled,
          fixDate(data.LastLessonDate),
          fixDate(data.NextLessonTime)
        ],
        road_test: [
          fixDate(data.RTDate),
          fixTime(data.RTTime),
          data.RTSite,
          data.withCar === "YES" ? "With Car" : "Without Car"
        ]
      };
      const newState = { ...this.state };
      newState.appointment = data;
      newState.body = body;
      this.setState(newState);
    } catch (error) {}
  };
  componentWillMount() {
    if (this.props.loading === false) {
      this.updateDisplay();
    }
    localStorage.removeItem("oldData");
  }
  componentDidMount() {
    // If we need to load page data.
    if (Object.keys(this.props.appointments)[0] === undefined) {
      this.props.dispatch(fetchProducts());
    }
    // Now check to see if we need to check for new payments.
    if (this.state.appointment && !this.state.newPayments) {
      const { StudentID } = this.state.appointment;
      this.loadRecentPayments(StudentID);
    }
    // Start up our auto update timer.
    this.appointmentDebounce();
    // Make sure we are scrolled to the top of the page.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.match.params.sid !== prevProps.match.params.sid) {
      this.updateDisplay();
    }
    if (this.state.appointment && !this.state.newPayments) {
      const { StudentID } = this.state.appointment;
      // const StudentID = 1;
      this.loadRecentPayments(StudentID);
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });

    const oldData = localStorage.getItem("oldData");
    if (oldData && oldData !== md5(JSON.stringify(this.state.appointment))) {
      alert(refreshAlertText);
      localStorage.removeItem("oldData");
    }
    this.appointmentDebounce();
  }
  componentWillUnmount() {
    localStorage.removeItem("oldData");
    this.appointmentDebounce.cancel();
  }
  render() {
    if (this.state.appointment === null) {
      this.updateDisplay();
    }
    if (this.state.appointment !== null) {
      return (
        <div className="instructor-dash-wrapper">
          <BackButton
            path={`/app/instructor-dashboard/${this.props.match.params.day}`}
          />
          <ScheduleEntryTitle appointment={this.state.appointment} />
          <MustPay header="Must Pay" pay={this.state.appointment.Pay} />
          <MustPay header="Balance" pay={this.state.appointment.Balance} />
          {this.state.newPayments ? (
            <PaymentWarning>
              Student has paid <span>${this.state.newPayments}</span> in the
              last 24 hours.
            </PaymentWarning>
          ) : null}
          {/* Adding a manual group. We only really need one. */}
          <div className="card-group-wrapper">
            <h4 className="card-group-title">Instructor Notes</h4>
            <Paragraph body={this.state.body.appointment[0]} />
          </div>
          <CardGroup
            grouptitle="Student Details"
            headers={this.headers.student}
            body={this.state.body.student}
          />
          <CardGroup
            grouptitle="Lesson Details"
            headers={this.headers.lesson}
            body={this.state.body.lesson}
          />
          <CardGroup
            grouptitle="Road Test Details"
            headers={this.headers.road_test}
            body={this.state.body.road_test}
          />
        </div>
      );
    } else {
      return (
        <div className="instructor-dash-wrapper">
          <h2>Loading Appointment...</h2>
        </div>
      );
    }
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(InstructorDashboard)
);
